
import './App.css';
import React, { useState, useEffect } from 'react';

import LuLaCalendar from "./components/LuLaCalendar";
import LuLaSlotPicker from "./components/LuLaSlotPicker";
import LuLaBookingInfo from "./components/LuLaBookingInfo";
import LuLaStepper from "./components/LuLaStepper";

import ReactGA from "react-ga4";

export const TIME_START_VALUE = '-';


function App() {
    const [date, setDate] = useState(new Date());
    const [time, setpTime] = useState(TIME_START_VALUE);
    const [slots, setSlots] = useState(null);
    const [loading, setLoading] = useState(true);
    const [page, setPage] = useState(1);
    const [bookingId, setBookingId] = useState(null);

    const [error, setError] = useState(null);

    useEffect(() => {
        try {
            ReactGA.initialize("AW-16576076002/c3DZCMin5cIZEOKxi-A9");
        } catch (e) {
            console.error("GA init failed:", e);
        }

        async function fetchData() {
            try {
                if (process.env.NODE_ENV === 'development') console.log("loading data..." + new Date());
                const response = await fetch(process.env.REACT_APP_API + 'slots');
                const json = await response.json();
                if (process.env.NODE_ENV === 'development') console.log(json);
                setSlots(json);
                setLoading(false);
            } catch (e) {
                console.error("Failed to load slots:", e);
                setError("Kunde inte ladda bokningsdata. Försök ladda om sidan.");
                setLoading(false);
            }
        }
        fetchData();    // initial load
        const interval = setInterval( () => {
            fetchData();
            }, 5*60*1000 );   // continuous reload every 5 min

        return () => clearInterval(interval);
    }, []);

    if (loading) {
        return <div>Laddar...</div>;
    }

    if (error) {
        return <div className="container"><div className="alert alert-danger mt-3">{error}</div></div>;
    }

    const canClickNext = time !== TIME_START_VALUE;

    const LL_HEADER = "Boka besök på Lustiga Landet";

    const page_1 = (
        <section className="page-section">
            <LuLaStepper pCurrentStep={1} />
            <h1 className='md3-headline text-center'>{LL_HEADER}</h1>
            <p className="md3-intro-text">
                Du behöver förboka ditt besök hos oss, men betalar på plats när du kommer.
                Vi har valt att ha förbokningar för att ni ska få en så bra upplevelse som möjligt.
                Det gör att det aldrig blir för många besökare och att de blir utspridda över dagen.
                Välj datum du vill komma, sedan tid och därefter klickar du på "Nästa steg".
            </p>
            <p className="md3-intro-text">
                Vad kostar ett besök? Se våra <a href="https://www.lustigalandet.se/intradespriser/" target="_blank" rel="noopener noreferrer">inträdespriser</a>.
            </p>
            <div className="md3-legend" style={{justifyContent: 'center'}}>
                <span className="md3-chip md3-chip--green">Gott om plats</span>
                <span className="md3-chip md3-chip--amber">Många bokningar</span>
                <span className="md3-chip md3-chip--red">Fullbokat</span>
            </div>
            <p className="md3-legend-note">
                <span className="md3-legend-note__hint">Gråmarkerade</span> datum är inte bokningsbara. Det kan betyda att vi har stängt eller att vi inte har lagt ut några tider än.
            </p>

            <div className="row justify-content-sm-center">
                <div className="col-sm-6">
                    <LuLaCalendar pDate={date} setDate={setDate} slots={slots} setTime={setpTime} defaultTimeValue={TIME_START_VALUE}/>
                </div>
                <div className="col-sm-6">
                    <LuLaSlotPicker pDate={date} pSlots={slots} pTime={time} setTime={setpTime}/>
                </div>
            </div>
            <div className="md3-btn-row" style={{justifyContent: 'flex-end', marginTop: '24px'}}>
                <button
                    type="button"
                    className="md3-btn md3-btn--filled"
                    disabled={!canClickNext}
                    onClick={() => setPage(2)}
                >
                    Nästa steg
                </button>
            </div>

            {process.env.REACT_APP_STAGE === 'dev' &&
            <div>
                STAGE= {process.env.REACT_APP_STAGE} NODE_ENV={process.env.NODE_ENV}, API={process.env.REACT_APP_API}
            </div>
            }
        </section>
    );


    const page_2 = (
        <section className="page-section">
            <LuLaStepper pCurrentStep={2} />
            <h1 className='md3-headline text-center'>{LL_HEADER}</h1>

            <div className="row g-4 justify-content-sm-center">
                <div className="col-12 col-md-7">
                    <LuLaBookingInfo pDate={date} pTime={time} setPage={setPage} setBookingId={setBookingId} />
                </div>
                <div className="col-12 col-md-5">
                    <div className="md3-info-card">
                        <h3>
                            <svg className="icon-svg--small" viewBox="0 0 24 24" fill="currentColor" style={{verticalAlign: '-3px', marginRight: '6px'}}><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"/></svg>
                            Information
                        </h3>
                        <p>För att undvika dubbelbokningar ber vi dig att:</p>
                        <p>- Kontrollera så att du angivit en korrekt e-postadress</p>
                        <p>- Om din bokningsbekräftelse inte kommit fram, titta i skräpposten</p>
                        <h3>
                            <svg className="icon-svg--small" viewBox="0 0 24 24" fill="currentColor" style={{verticalAlign: '-3px', marginRight: '6px'}}><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"/></svg>
                            Priser
                        </h3>
                        <p>Vad kostar ett besök? Se våra <a href="https://www.lustigalandet.se/intradespriser/" target="_blank" rel="noopener noreferrer">inträdespriser</a>.</p>
                    </div>
                </div>
            </div>
        </section>
    );


    const page_3_thanks = (
        <section className="page-section">
            <LuLaStepper pCurrentStep={3} />
            <h1 className='md3-headline text-center'>{LL_HEADER}</h1>

            <div className="md3-card">
                <div className="md3-card-content">
                    <div className="md3-confirmation">
                        <div className="md3-confirmation-icon">
                            <svg className="icon-svg--large" viewBox="0 0 24 24" fill="currentColor"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg>
                        </div>
                        <div style={{textAlign: 'center'}}>
                            <h2>Tack för din bokning!</h2>
                            <div className="md3-booking-number">
                                Ditt bokningsnummer är: {bookingId}
                            </div>
                        </div>
                        <p>
                            Du kommer även att få en bokningsbekräftelse till den epost du angav.
                            Ta med bokningsnumret vid ditt besök.
                        </p>
                        <p>
                            Du betalar ditt besök när du kommer.
                            Behöver du avboka eller har frågor om ditt besök så mailar du till: kontakt@lustigalandet.se
                        </p>
                        <p>Varmt välkommen!<br/>Mvh Lustiga Landet</p>
                    </div>
                </div>
            </div>
        </section>
    );

    return (
        (page === 1) ? page_1 : ( (page === 2 ) ? page_2 : page_3_thanks )
    );
}

export default App;
